import React from "react";
import SideNav from "./navigation/SideNav";
import SideNavMobile from "./navigation/SideNavMobile";

const style = {
  container_mobile: {
    display: "flex",
    flexDirection: "column", //Change
  },
  container_desktop: {
    display: "flex",
    flexFlow: "row",
  },
  content: {
    margin: 0, //in mobile, change to 0
    width: "100%",
    height: "100vh",
    overflowY: "auto",
  },
};

export default ({
  children,
  title = "",
  targetDevice = "desktop",
  whiteLabelSettings,
}) => (
  <div style={style.container_mobile}>
    <SideNavMobile title={title} targetDevice={targetDevice} />
    <div style={style.container_desktop} className="temp">
      <SideNav targetDevice={targetDevice} />
      <div style={style.content}>{children}</div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/layout/AppFrame.js